import React from "react";
import { LogUploadSourceType } from "types/api/aiRiskMgmt";

import { LogFileUpload } from "../GenericIntegration";

export default function CrowdStrikeEdrFileUpload() {
  return (
    <LogFileUpload
      sourceType={LogUploadSourceType.CROWDSTRIKE_EDR}
      label="CrowdStrike EDR"
    />
  );
}
